// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__L2KDf","icon":"Checkbox_icon__cqOQj"};